import PropTypes from 'prop-types';

import AdSenseSlot, { AD_SLOTS } from '.';

// Slot name → width/height config
const SLOT_CONFIGS = {
  SIDEBAR_300x250: { width: 300, height: 250 },
};

// Wraps AdSenseSlot for named-slot usage without a LazyHydration outer wrapper.
// LazyHydration + AdSense causes a ResizeObserver loop (incidents f2b8a6982, 451fc2750).
const LazyHydratedAdSenseSlot = ({ slot, ...rest }) => {
  const config = SLOT_CONFIGS[slot];

  if (!config) return null;

  return (
    <AdSenseSlot
      height={config.height}
      slotId={AD_SLOTS[slot]}
      width={config.width}
      {...rest}
    />
  );
};

LazyHydratedAdSenseSlot.propTypes = {
  slot: PropTypes.oneOf(Object.keys(SLOT_CONFIGS)).isRequired,
};

export default LazyHydratedAdSenseSlot;
